// extracted by mini-css-extract-plugin
export default {"requirementsGrid":"_6a2154ab","header":"_88e0b0a0","iconContainer":"_7bd1a893","circle":"_f7b47a6d","checkmark":"_53a5266c","xMark":"_2c9a9cf2","notCompletedRequirement":"_2df28538"};